import styled from 'styled-components';
import {Link} from 'react-router-dom'


function BlogCard(props) {

  return (
    <Container>

            <Card>
                <Link to={`/${props.blogID}`}>
                <img src={props.image} alt="" />
                <span> <i class="fa-solid fa-clock-rotate-left"></i> {props.date}</span>
                <h1>{props.title} </h1>
                {/* <a href="#readmore">READ MORE</a> */}
                <p id='read-more'>READ MORE </p>
                </Link>
            </Card>        
    </Container>
  )
}

export default BlogCard
const Container = styled.div`

#hover-to-show{
    display:none;
    background-color:none;
    font-weight:bold ;
    font-size:16px ;
    font-family:Arial ;
}
h1:hover #more-dot{
    display:none ;
}

h1:hover #hover-to-show{
    display:flex ;
}
        h1{
                font-size: 1rem;
                padding:10px;
                padding-bottom:0 ;
                font-weight:bold ;
                color:black ;
                /* font-family: Montserrat; */
                line-height:1.3em ;
                text-align:left ;


            }
         img{
            object-fit: cover;
            height:200px ;
            width:100% ;
            transition: all .2s ease-in-out; 
            /* border-radius: 10px 10px 0 0 ; */
        }

        img:hover{
            transform:scale(1) ;
        }
        h1:hover{
            text-decoration:underline ;
        }
        a{
            /* text-align:center ; */
            text-decoration:none ;
            font-size:20px;
            color:#FA7525 ;
        }
        
        border-radius: 10px 10px 0 0 ;

display:grid;
grid-gap:20px ;
box-sizing:border-box;
grid-template-rows: 350px ;

#read-more{
    position:absolute ;
    bottom:0 ;
    right:20px ;
    color:#FA7525 ;
    &:hover{
        color:blue ;
    }
}

`   
const Card = styled.div`
box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;
box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;

        h1{
            overflow:hidden ;
            text-overflow:ellipsis ;
        }

span{
    color:black ;
    font-size:12px ;
    background-color:#F1F5F9;
}
cursor: pointer;
border-radius:10px 10px 0 0 ;
transition: all ease .5s;
&:hover{
    transform: translateY(-10px);
    background-color:#F5F5F5 ;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;

}



`